import TipoServicioService from 'src/modules/tipoServicio/tipoServicioService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'TIPOSERVICIO_FORM';

const tipoServicioFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: tipoServicioFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await TipoServicioService.find(id);
      }

      dispatch({
        type: tipoServicioFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: tipoServicioFormActions.INIT_ERROR,
      });

      getHistory().push('/tipo-servicio');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: tipoServicioFormActions.CREATE_STARTED,
      });

      await TipoServicioService.create(values);

      dispatch({
        type: tipoServicioFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.tipoServicio.create.success'),
      );

      getHistory().push('/tipo-servicio');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: tipoServicioFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: tipoServicioFormActions.UPDATE_STARTED,
      });

      await TipoServicioService.update(id, values);

      dispatch({
        type: tipoServicioFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.tipoServicio.update.success'),
      );

      getHistory().push('/tipo-servicio');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: tipoServicioFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default tipoServicioFormActions;
